import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router';

import restaurantLocations from 'locations/reducers';
import locationThrottledTimes from 'locations/reducers/locationThrottledTimes';
import locationInventory from 'locations/reducers/locationInventory';
import account from 'account/reducers';
import cart from 'cart/reducers';
import lastItem from 'cart/reducers/lastItem';
import cartAvailable from 'cart/reducers/cartAvailable';
import orderAmount from 'cart/reducers/orderAmount';
import menu, { menuItemsDetail, productPreview } from 'menus/reducers';
import modal from 'base/reducers/modal';
import cartWorkingCopy from 'cart/reducers/cartWorkingCopy';
import notificationModal from 'base/reducers/notificationModal';
import alertStatusReducer from 'base/reducers/alertStatus';
import tracking from 'base/reducers/tracking';
import googleMapsStaticUrl from 'base/reducers/googleMapsStaticUrl';
import setupDataFactory from 'base/reducers/setupDataFactory';
import libraryLoad from 'base/reducers/libraryLoad';
import scrollManager from 'base/reducers/scrollManager';
import cartValidation from 'cart/reducers/cartValidation';
const user = setupDataFactory('user');

export default history =>
  combineReducers({
    restaurantLocations,
    locationInventory,
    locationThrottledTimes,
    account,
    cart,
    cartAvailable,
    orderAmount,
    menu,
    modal,
    productPreview,
    menuItemsDetail,
    notificationModal,
    lastItem,
    tracking,
    googleMapsStaticUrl,
    form: formReducer,
    cartWorkingCopy,
    alertStatus: alertStatusReducer,
    router: connectRouter(history),
    user,
    libraryLoad,
    scrollManager,
    cartValidation
  });
